import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IYearMonth } from '@/coreDomainsModule/date';
import { BusinessesForSupplierForecastHeaderKey, TableContentProperty } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import TableCell from '../TableCell.vue';
import SupplierForecastCreationStatusIcon from './SupplierForecastCreationStatusIcon.vue';
import { BusinessesForSupplierForecastTableContentViewModel } from './businessesForSupplierForecastTableContentViewModel';
import { computed } from 'vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessesForSupplierForecastTableCell',
  props: {
    header: {},
    headerKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isBold: { type: Boolean },
    forecastStartYearMonth: { default: undefined },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["onClickNarrow"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

const businessesForSupplierForecastTableContentVM = new BusinessesForSupplierForecastTableContentViewModel();

const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCell, {
    class: _normalizeClass([[_unref(businessesForSupplierForecastTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
    style: _normalizeStyle({
      left: _unref(businessesForSupplierForecastTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    "text-align": textAlign.value,
    "table-content-property": _ctx.header,
    "tool-tip-value": _unref(businessesForSupplierForecastTableContentVM).displayForecastForReceiptItem(_ctx.headerKey, _ctx.item, _ctx.forecastStartYearMonth),
    "is-highlighted": props.isChecked || props.isCheckedBusinessId
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["table-cell-content", { 'table-cell-content': _ctx.isBold }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickNarrow')))
      }, _toDisplayString(_unref(businessesForSupplierForecastTableContentVM).displayForecastForReceiptItem(_ctx.headerKey, _ctx.item, _ctx.forecastStartYearMonth)), 3)
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "text-align", "table-content-property", "tool-tip-value", "is-highlighted"]))
}
}

})